import lightGallery from "lightgallery";
import { clearQueueScrollLocks, disablePageScroll, enablePageScroll } from "scroll-lock";

export default function gallery() {
  let galleries = $('.gallery');
  Array.from(galleries).forEach(function(gallery) {
    lightGallery(gallery, {
      licenseKey: 'UNLICENSED',
      controls: true,
    });
  });
  $('.contacts__slider, .lg-outer, .contacts__slider .swiper-slide').on('click', function() {
    if ($(window).width() > 1280) {
      if ($('html').hasClass('lg-on')) {
        disablePageScroll();
      } else {
        clearQueueScrollLocks();
        enablePageScroll();
      }
    }
  });
  $('.contacts__slider .swiper-slide').on('click', function() {
    $(this).next().find('img').trigger("click");
    $(this).next().next().find('img').trigger("click");
  });
  $(window).on('keydown', function(e) {
    if ( e.keyCode == 27 ) {
      clearQueueScrollLocks();
      enablePageScroll();
    }
  });
}
gallery();